// function calcResultCart() {
// 	let price = 0;
// 	let discount = 0;
// 	let count = $('.cart-checkout__item').length;

// 	// скрываем скидку если нет комплекта
// 	if (count < $('.cart-checkout').data('complect')) {
// 		$('.cart-checkout__discount').hide();
// 	}

// 	// складываем цены
// 	$('.cart-checkout__item').each((i, el) => {
// 		let elPrice = $(el).data('price');

// 		price += elPrice;
// 	})

// 	// если есть скидка, то отнимаем её от цены
// 	if ($('.cart-checkout__discount').length && $('.cart-checkout__discount').is(':visible')) {
// 		discount = $('.cart-checkout__discount').data('price');

// 		if (discount > 0) {
// 			price -= discount;
// 		}
// 	}
// 	$('.cart-checkout__result span').text(price);
// }

// calcResultCart();

// $('.js-cart-checkout-item-delete').on('click', (e) => {
// 	$(e.currentTarget).closest('.cart-checkout__item').remove();

// 	calcResultCart();
// });

$(".cart-promo__title").click(function(){
	$(".cart-promo__content").slideToggle(300);
})

$(".password-toggler").click(function(){
    $(this).toggleClass("password-toggler--show");
    let input = $(this).siblings("input");
    let attr = input.attr("type");
    input.attr("type", (attr == "password" ? "text" : "password" ));
})